import React, { useState, useEffect } from 'react';
import WeeklyTrendChart from './WeeklyTrendChart';
import WeeklyRevenueDashboard from './WeeklyRevenueDashboard';
import { fetchUniqueStreams } from '../services/streamService';

const WeeklyRevenueDashboardContainer = () => {
  const [selectedStream, setSelectedStream] = useState('');
  const [streams, setStreams] = useState([]);
  const [loadingStreams, setLoadingStreams] = useState(true);
  useEffect(() => {
  const getStreams = async () => {
    try {
      const data = await fetchUniqueStreams();
      // Safeguard: Ensure data is an array before setting state
      if (Array.isArray(data)) {
        setStreams(data);
      } else {
        console.error("API returned non-array data:", data);
        setStreams([]);
      }
    } catch (err) {
      console.error("Failed to fetch revenue streams:", err);
      setStreams([]);
    } finally {
      setLoadingStreams(false);
    }
  };
  getStreams();
}, []);

  return (
    <div className="p-3 space-y-1 bg-gray-50 min-h-screen"> 
      <div className="flex flex-col md:flex-row md:items-center justify-between bg-white p-4 rounded-xl shadow-sm border">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Revenue Streams Weekly Performance</h1>
          <span className="text-gray-500 text-sm"> (Real-time Tracking of County Revenue Streams Weekly Collections)</span>
        </div>

        <div className="mt-4 md:mt-0 flex items-center space-x-3">
          <label className="text-sm font-medium text-gray-700">Filter Stream:</label>
          <select 
            value={selectedStream}
            onChange={(e) => setSelectedStream(e.target.value)}
            className="rounded-lg border-gray-300 text-sm focus:ring-blue-500 focus:border-blue-500 p-2.5 bg-white border"
          >
            <option value="">All Streams (Total)</option>
            {streams.map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Side-by-Side Layout: 2/3 Chart and 1/3 Dashboard */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
        
        {/* Left Section: Trend Chart (Spans 1 column on large screens) */}
        <div className="lg:col-span-1 bg-white rounded-xl shadow-sm border p-4">
          <WeeklyTrendChart 
            key={`chart-${selectedStream}`} 
            stream={selectedStream} 
          />
        </div>

        {/* Right Section: Weekly Data Table (Spans 2 columns) */}
        <div className="lg:col-span-2 bg-white rounded-xl shadow-sm border p-4">
          <div className="h-full overflow-hidden">
              <WeeklyRevenueDashboard 
                key={`table-${selectedStream}`} 
                stream={selectedStream} 
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklyRevenueDashboardContainer;